import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[onlyNumericCharAllowed]'
})
export class OnlyNumericCharAllowedDirective {

  public regexStr = '^[0-9]*$';

  constructor(private el: ElementRef) {}

  @HostListener('keypress', ['$event']) onKeyPress(event) {
      return new RegExp(this.regexStr).test(event.key);
  }

  @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
      this.validateFields(event);
  }

  validateFields(event) {
    setTimeout(() => {
      if (!new RegExp(this.regexStr).test(this.el.nativeElement.value)) {
        this.el.nativeElement.value = null;
        event.preventDefault();
      }
    }, 100)
  }

}
